import _extends from 'babel-runtime/helpers/extends';

import isStringOrStringArray from '@/utils/isStringOrStringArray';

export default {
  name: 'AccountMgrSelector',

  componentName: 'AccountMgrSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    accountMgrs: function accountMgrs() {
      var _this = this;

      if (this.$store.getters.account_mgr) {
        return this.$store.getters.account_mgr.map(function (item) {
          return {
            value: isStringOrStringArray(_this.formValue[_this.innerConfig.prop]) ? String(item.id) : Number(item.id), // 兼容传入参数的类型
            label: item.real_name
          };
        });
      }
      return [];
    },
    innerConfig: function innerConfig() {
      var params = _extends({
        clearable: true,
        placeholder: '请选择AM'
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  mounted: function mounted() {
    if (this.accountMgrs && !this.accountMgrs.length) {
      this.$store.dispatch('GetAccountMgr');
    }
  }
};